import { Box, Hide, Show, Text } from '@chakra-ui/react';
import { ClientOnly, Grid } from '@time-line/components/common';
import type { ProductComparison as ProductComparisonProps } from 'types/cms/blocks';

import { Carousel } from './Carousel';
import { Table } from './Table';

export function ProductComparison({
  title,
  products,
  table,
  promoCode,
  ctaType,
  imageType,
}: ProductComparisonProps) {
  if (!products.every((product) => product.slug)) return null;

  const hasMoreThanFourProducts = products.length > 4;

  return (
    <Box className="section--productComparison" my="2xl">
      <Grid rowGap="m">
        <Grid.Inner>
          <Text
            as="h2"
            size={{ base: 'h2', lg: 'h3' }}
            gridColumn="span 12"
            textAlign={hasMoreThanFourProducts ? 'left' : 'center'}
            display={{ lg: hasMoreThanFourProducts ? 'block' : 'none' }}
          >
            {title}
          </Text>
        </Grid.Inner>
        <Grid.Inner gridColumn={{ base: 'full', md: 'main' }}>
          <Box gridColumn="span 12">
            <ClientOnly>
              <Show below="md">
                <Carousel
                  products={products}
                  table={table}
                  promoCode={promoCode}
                  display={{ base: 'block', md: 'none' }}
                  ctaType={ctaType}
                  imageType={imageType}
                />
              </Show>
            </ClientOnly>
            <Hide below="md">
              <Table
                title={title}
                table={table}
                products={products}
                promoCode={promoCode}
                display={{ base: 'none', md: 'block' }}
                ctaType={ctaType}
                imageType={imageType}
              />
            </Hide>
          </Box>
        </Grid.Inner>
      </Grid>
    </Box>
  );
}
